import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import CancelPayment from '../components/Invoice/CancelPayment';
import { cancelPayment, rescheduleCancelSuccess } from '../actions/invoiceVendorAction';

function mapStateToProps(state) {
  return {
    cancelSuccess: state.Invoice.cancelSuccess || false,
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      cancelPayment,
      rescheduleCancelSuccess
    },
    dispatch,
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(CancelPayment);
